import Vue from 'vue'

import Spin from './spin'
import Tree from './tree'
import Avatar from './avatar'
import Badge from './badge'
import Tag from './tag'
import { Tabs , TabPane } from './tabs'
import { Row , Col } from './grid'
import List from './list'
import Editor from './editor'
import { Search , SearchItem } from './search'
import { DetailList , DetailListItem } from './detail-list'
import CitySelect from './city-select'
import Permission from './permission'
import Keepalive from './keepalive'
import Scroll from './scroll'
import Reload from './reload'
import Video from './video'
import Label from './label'
import Checkbox from './checkbox'

// import { TimePicker , Pagination , SearchCombo , Area  , Select } from './vuex'

const Components = [Label,Checkbox,Spin,Tree,Avatar,Badge,Tag,Tabs ,TabPane, Search , SearchItem , DetailList , DetailListItem , List , Editor , CitySelect , Keepalive,Scroll,Video,
// TimePicker , Pagination , SearchCombo , Area , Select, 
Reload,
Permission]
const prefix = 'sl'

let customComponents = {}

const install = (Vue) => {
  Components.forEach(i => {
    if (i.install) {
      Vue.use(i)
    } else {
      Vue.component(prefix+i.name, i)
    }
  })
}

if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}

customComponents.install = install

export default customComponents